module.exports = __webpack_public_path__ + "img/6x2.9e0107f6.png";